import PropTypes from 'prop-types'
import { cn } from 'lib/utils'
import { Label } from '@components/ui/label'
import { Input } from '@components/ui/input'
import { Textarea } from '@components/ui/textarea'

export const AdasTextField = ({
  disabled,
  innerRef,
  inputRef,
  multiline,
  rows = 3,
  label,
  value,
  onChange,
  placeholder,
  error,
  helperText,
  fullWidth = true,
  required,
  className,
  id,
  name,
  type = 'text',
  InputProps,
  inputProps,
  size,
  minLength,
  // eslint-disable-next-line no-unused-vars
  sx,
  // eslint-disable-next-line no-unused-vars
  variant,
  // eslint-disable-next-line no-unused-vars
  InputLabelProps,
  // eslint-disable-next-line no-unused-vars
  FormHelperTextProps,
  ...props
}) => {
  const ref = inputRef || innerRef
  const inputId = id || name
  const inputClass = cn(
    'border-custom-borderInput',
    size === 'small' && 'h-8 text-xs',
    error && 'border-error focus-visible:ring-error',
    fullWidth && 'w-full'
  )

  return (
    <div className={cn('flex flex-col gap-1', fullWidth && 'w-full', className)}>
      {label && (
        <Label htmlFor={inputId} className={cn('text-xs font-medium text-text-primary', error && 'text-error')}>
          {label}
          {required && <span className='text-error ml-1'>*</span>}
        </Label>
      )}
      {multiline ? (
        <Textarea
          id={inputId}
          name={name}
          ref={ref}
          disabled={disabled}
          {...(value !== undefined ? { value: value ?? '' } : {})}
          onChange={onChange}
          placeholder={placeholder}
          rows={rows}
          className={inputClass}
          {...props}
          {...inputProps}
        />
      ) : (
        <div className='relative flex items-center w-full'>
          {InputProps?.startAdornment && (
            <span className='absolute left-2 flex items-center pointer-events-none'>{InputProps.startAdornment}</span>
          )}
          <Input
            id={inputId}
            name={name}
            ref={ref}
            type={type}
            disabled={disabled}
            {...(value !== undefined ? { value: value ?? '' } : {})}
            onChange={onChange}
            placeholder={placeholder}
            required={required}
            minLength={minLength}
            className={cn(inputClass, InputProps?.startAdornment && 'pl-8', InputProps?.endAdornment && 'pr-8')}
            {...props}
            {...inputProps}
          />
          {InputProps?.endAdornment && <span className='absolute right-2 flex items-center'>{InputProps.endAdornment}</span>}
        </div>
      )}
      {helperText && <p className={cn('text-xs', error ? 'text-error' : 'text-text-secondary')}>{helperText}</p>}
    </div>
  )
}

AdasTextField.propTypes = {
  disabled: PropTypes.bool,
  innerRef: PropTypes.object,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  fullWidth: PropTypes.bool,
  required: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.string
}
